interface PaginationMeta {
  current_page: number;
  last_page: number;
  per_page: number;
  total: number;
  from?: number;
  to?: number;
}

interface PaginationProps {
  meta: PaginationMeta;
  page: number;
  onPageChange: (page: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({
  meta,
  page,
  onPageChange,
}) => {
  if (meta.last_page <= 1) {
    return null;
  }

  return (
    <div className="flex flex-col md:flex-row justify-between items-center gap-5 mt-10 py-3 border-t-2 border-gray-200">
      {/* TOTAL */}
      <div className="px-6 py-3 rounded-full bg-indigo-100 text-indigo-700 font-semibold">
        Showing {meta.from ?? 0}-{meta.to ?? 0} of {meta.total} records
      </div>

      {/* PAGINATION */}
      <div className="flex flex-wrap justify-center items-center gap-2">
        {/* PREV */}
        <button
          disabled={page === 1}
          onClick={() => onPageChange(page - 1)}
          className="px-4 py-2 rounded-full bg-indigo-500 text-white disabled:opacity-50 disabled:cursor-not-allowed hover:bg-indigo-600 transition"
        >
          Prev
        </button>

        {/* PAGE NUMBERS */}
        {Array.from({ length: meta.last_page }, (_, index) => index + 1).map(
          (pageNumber) => (
            <button
              key={pageNumber}
              onClick={() => onPageChange(pageNumber)}
              className={`w-10 h-10 rounded-full font-semibold transition ${
                page === pageNumber
                  ? "bg-indigo-600 text-white scale-110"
                  : "bg-indigo-100 text-indigo-700 hover:bg-indigo-600 hover:text-white"
              }`}
            >
              {pageNumber}
            </button>
          ),
        )}

        {/* NEXT */}
        <button
          disabled={page === meta.last_page}
          onClick={() => onPageChange(page + 1)}
          className="px-4 py-2 rounded-full bg-indigo-500 text-white disabled:opacity-50 disabled:cursor-not-allowed hover:bg-indigo-600 transition"
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default Pagination;
